import React from 'react';
import { Alert } from 'vdlib';
import DependentDataProvider from 'components/context/DependentData';

const fixedHeaderHeight = 50;

const Main = ({ alert, children, hideAlert }) => {
  const contentRef = React.useRef(null);

  const handleWindowResize = () => {
    if (contentRef.current)
      contentRef.current.style['min-height'] = `${
        window.innerHeight - fixedHeaderHeight
      }px`;
  };

  React.useEffect(() => {
    window.addEventListener('resize', handleWindowResize, false);

    return () => {
      window.removeEventListener('resize', handleWindowResize, false);
    };
  }, []);

  React.useEffect(() => {
    if (contentRef.current) handleWindowResize();
  }, [contentRef]);

  return (
    <DependentDataProvider>
      <div className="page-content-wrapper">
        <div className="page-content" ref={contentRef}>
          {alert && (
            <Alert
              className="main-alert"
              text={alert.text}
              type={alert.type}
              duration={alert.duration}
              onHide={hideAlert}
            />
          )}
          {children}
          <div className="clearfix" />
        </div>
      </div>
    </DependentDataProvider>
  );
};

export default Main;
